import CaptchaInput from './CaptchaInput';
import CheckboxInput from './CheckboxInput';
import EmailInput from './EmailInput';
import HiddenInput from './HiddenInput';
import MultiSelectInput from './MultiSelectInput';
import NumberInput from './NumberInput';
import PhoneInput from './PhoneInput';
import RadioInput from './RadioInput';
import SelectInput from './SelectInput';
import TextAreaInput from './TextAreaInput';
import TextInput from './TextInput';
import { GravityFormFragmentFormFieldNodes } from '../types';

export const mapFormFieldsToInputs = function(node: GravityFormFragmentFormFieldNodes[number]) {
  if (!node.__typename) {
    return null;
  }

  switch (node.__typename) {
    // supported fields
    case 'CaptchaField': {
      return (
        <CaptchaInput
          field={node}
          key={node.id}
        />
      );
    }
    case 'CheckboxField': {
      return (
        <CheckboxInput
          field={node}
          key={node.id}
        />
      );
    }
    case 'EmailField': {
      return (
        <EmailInput
          field={node}
          key={node.id}
        />
      );
    }
    case 'HiddenField': {
      return (
        <HiddenInput
          field={node}
          key={node.id}
        />
      );
    }
    case 'MultiSelectField': {
      return (
        <MultiSelectInput
          field={node}
          key={node.id}
        />
      );
    }
    case 'NumberField': {
      return (
        <NumberInput
          field={node}
          key={node.id}
        />
      );
    }
    case 'PhoneField': {
      return (
        <PhoneInput
          field={node}
          key={node.id}
        />
      );
    }
    case 'RadioField': {
      return (
        <RadioInput
          field={node}
          key={node.id}
        />
      );
    }
    case 'SelectField': {
      return (
        <SelectInput
          field={node}
          key={node.id}
        />
      );
    }
    case 'TextAreaField': {
      return (
        <TextAreaInput
          field={node}
          key={node.id}
        />
      );
    }
    case 'TextField': {
      return (
        <TextInput
          field={node}
          key={node.id}
        />
      );
    }
    case 'AddressField':
    case 'DateField':
    case 'NameField':
    case 'TimeField':
    case 'WebsiteField':
    case 'ConsentField':
    case 'FileUploadField':
    case 'HtmlField':
    case 'ImageChoiceField':
    case 'ListField':
    case 'MultiChoiceField':
    case 'OptionCheckboxField':
    case 'OptionRadioField':
    case 'OptionSelectField':
    case 'PageField':
    case 'PasswordField':
    case 'PostCategoryCheckboxField':
    case 'PostCategoryMultiSelectField':
    case 'PostCategoryRadioField':
    case 'PostCategorySelectField':
    case 'PostContentField':
    case 'PostCustomCheckboxField':
    case 'PostCustomDateField':
    case 'PostCustomEmailField':
    case 'PostCustomFileuploadField':
    case 'PostCustomHiddenField':
    case 'PostCustomListField':
    case 'PostCustomMultiSelectField':
    case 'PostCustomNumberField':
    case 'PostCustomPhoneField':
    case 'PostCustomRadioField':
    case 'PostCustomSelectField':
    case 'PostCustomTextAreaField':
    case 'PostCustomTextField':
    case 'PostCustomTimeField':
    case 'PostCustomWebsiteField':
    case 'PostExcerptField':
    case 'PostImageField':
    case 'PostTagsCheckboxField':
    case 'PostTagsMultiSelectField':
    case 'PostTagsRadioField':
    case 'PostTagsSelectField':
    case 'PostTagsTextField':
    case 'PostTitleField':
    case 'ProductCalculationField':
    case 'ProductHiddenField':
    case 'ProductPriceField':
    case 'ProductRadioField':
    case 'ProductSelectField':
    case 'ProductSingleField':
    case 'QuantityHiddenField':
    case 'QuantityNumberField':
    case 'QuantitySelectField':
    case 'SectionField':
    case 'ShippingRadioField':
    case 'ShippingSelectField':
    case 'ShippingSingleField':
    case 'TotalField':
    default:
      return null;
  }
};
